module.exports = __webpack_public_path__ + "img/5.2d8aea04.jpg";